/* Publish by EComposer at 2025-08-08 13:16:24*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-uyc6tyx415b"]=  window.__ectimmers["ecom-uyc6tyx415b"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-uyc6tyx415b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uyc6tyx415b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8a5kavnjfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8a5kavnjfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wstsuacjfyl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wstsuacjfyl', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-onuxj53s1lq"]=  window.__ectimmers["ecom-onuxj53s1lq"] || {};
if(!this.$el)return!1;const e=this.$el;this.settings.animation&&function(t){if(!e)return;const n=e.querySelector(".ecom__element--button");if(!n)return;let s=parseInt(t.settings.animation_loop_time)*1e3||6e3,o=1e3;window.__ectimmers["ecom-onuxj53s1lq"]["wnrkdw5eg"] = setInterval(function(){n.classList.add("animated"),setTimeout(function(){n.classList.remove("animated")},o)},s)}(this);var i=e.querySelector(".ecom__element--button");this.isLive&&i&&i.dataset.ecTrackingId&&i.addEventListener("click",function(t){if(window.Shopify.analytics){t.preventDefault();let n=document.createElement("div");document.body.appendChild(n),n.click();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:i.id,tracking_id:i.dataset.ecTrackingId},s);Shopify.analytics.publish("ec_custom_events",o),i.cloneNode(!0).click()}},{once:!0}),this.isLive&&i&&i.dataset.eventTrackingFb&&i.addEventListener("click",function(t){window.fbq&&window.fbq("track",`${i.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-onuxj53s1lq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onuxj53s1lq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mwdgsbx052o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mwdgsbx052o', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-wgr6ukqzd1n"]=  window.__ectimmers["ecom-wgr6ukqzd1n"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-wgr6ukqzd1n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wgr6ukqzd1n', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-cynfwp2lhlu"]=  window.__ectimmers["ecom-cynfwp2lhlu"] || {};
if(!this.$el||!window.EComModal)return;const e=this.isLive;let i=this.$el.querySelectorAll("[ecom-modal]");i.length&&e&&new window.EComModal(i,{gallery:!0,cssClass:["ecom-container-lightbox-"+this.id]})

                    });
                    
                        document.querySelectorAll('.ecom-cynfwp2lhlu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cynfwp2lhlu', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}